import { JourneyStepChangedEvent } from './../../interfaces/events/journey-step-changed-event';
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { ContentSwitcher } from '@studyportals/content-switcher';
import { PageSectionType } from '../enums/page-section-type';
import { IActions } from '@/interfaces/store.interfaces';
import mutations from './mutations';
import globals from '@/utils/globals';
import store from '.';
import EvaluateStep from '@/domain/Journey/EvaluateStep';
import IStep from '@/interfaces/step.interface';
import DiscoverStep from '@/domain/Journey/DiscoverStep';
import CommitStep from '@/domain/Journey/CommitStep';
import GetReadyStep from '@/domain/Journey/GetReadyStep';
import StudyStep from '@/domain/Journey/StudyStep';
import { StudentField } from '@studyportals/studentdomain';
import PrepareToApplyStep from '@/domain/Journey/PrepareToApplyStep';
import { router } from '@/router/router';
import { IJourneyState } from '@studyportals/studentdomain/src/i-journey-state';
import { StepType } from 'interfaces/enums/step-type';

const actions: IActions = {
	initializeContentSwitcher: (section: PageSectionType, modules, options) => {
		const contentSwitcher: ContentSwitcher = new ContentSwitcher(modules, options);
		contentSwitcher.init();
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
		const currentUrl: URL = new URL(window.location as any);
		const urlParams = currentUrl.searchParams;
		const targetTab = urlParams.get('tab');

		mutations.setContentSwitcher(section, contentSwitcher);
		mutations.setActivePageSection(section);
		contentSwitcher.setActiveModule(targetTab);
	},
	setActiveView: (section: PageSectionType) => {
		mutations.setActivePageSection(section);
		actions.trackSectionSwitch(store.getters.activePageSection(), section);

		if (section === PageSectionType.RECOMMENDATIONS) {
			document.dispatchEvent(new CustomEvent('recommendations_impression'));
		}

		if (window.innerWidth < 768) {
			const targetSection = document.querySelector('[data-id="' + section + '"]');

			if (!targetSection) {
				return;
			}

			const targetSectionParent: HTMLElement = targetSection.parentNode! as HTMLElement;
			const targetSectionHeader: HTMLElement | null = targetSectionParent.querySelector('.MobileHeader');

			if (!targetSectionHeader) {
				return;
			}

			targetSectionHeader.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	},
	setGender: (gender) => {
		mutations.setGender(gender);
	},
	setName: (name) => {
		mutations.setName(name);
	},
	setCountriesOfInterest: (countries) => {
		mutations.setCountriesOfInterest(countries);
	},
	setAttendance: (attendance) => {
		mutations.setAttendance(attendance);
	},
	setDisciplinesOfInterest: (disciplines) => {
		mutations.setDisciplinesOfInterest(disciplines);
	},
	setProfileCompleteness: (completeness) => {
		mutations.setProfileCompleteness(completeness);
	},
	setIsInitialStudentDataLoaded: (loaded: boolean) => {
		mutations.setIsInitialStudentDataLoaded(loaded);
	},
	trackSectionSwitch: (from, to) => {
		globals.accountPageTracker.trackSectionSwitch(from, to);
	},
	setJourneySteps: () => {
		const evaluate = new EvaluateStep();
		const discover = new DiscoverStep();
		const prepareToApply = new PrepareToApplyStep();
		const commit = new CommitStep();
		const getReady = new GetReadyStep();
		const study = new StudyStep();
		const steps: IStep[] = [discover, evaluate, prepareToApply, commit, getReady, study];

		mutations.setJourneySteps(steps);
	},
	setInitialCurrentJourneyStep: async (): Promise<void> => {
		const activeStep = store.getters.getActiveJourneyStep();
		await router.replace({ name: activeStep?.stepType });
	},
	setJourneyState: (journeyState: IJourneyState | null): void => {
		mutations.setJourneyState(journeyState);
	},
	setStepCompleted: async (stepType: StepType) => {
		let journeyState = store.getters.getJourneyState();

		journeyState = {
			...journeyState,
			[stepType]: {
				completed: true,
				last_changed_date: new Date().toISOString().slice(0, 10),
			},
		};

		const studentData = {
			[StudentField.JOURNEY_STATE]: journeyState,
		};

		await globals.studentRepository.setData(studentData);
		store.mutations.setJourneyState(journeyState);
	},
	undoSetStepCompleted: async (stepType: StepType) => {
		const journeyState = store.getters.getJourneyState();

		if (journeyState && journeyState[stepType]) {
			delete journeyState[stepType];

			const studentData = {
				[StudentField.JOURNEY_STATE]: journeyState,
			};
			await globals.studentRepository.setData(studentData);
			store.mutations.setJourneyState(journeyState);
		}
	},
	setCurrentJourneyStepByType: (stepType: StepType) => {
		const step = store.getters.getStepByType(stepType);
		if (step) {
			store.mutations.setCurrentJourneyStep(step);
		}

		const event = new JourneyStepChangedEvent(stepType);
		globals.eventAggregationService.publishTo(JourneyStepChangedEvent.EventType, event);
	},
};

export default actions;
